export const Setting = {
  SELFCHECK_ASSIGN_INDEX: 0,
  SELFCHECK_CORE_INDEX: 3,
  SELFCHECK_LAST_INDEX: 3,
  SELFCHECK_EXTRA_SURVEY: {
    FCRI_SF: [0, 1, 2, 3],
    GAD7: [0, 1, 2, 3]
  },
  ENCOURAGE_MAIL_INDEXES: [1, 2, 3],
  SELFCHECK_PHQ9_ALERT_ANSWER_INDEX: 8,
  SELFCHECK_PHQ9_ALERT_ANSWER_ID: 'PHQ9_9',
  SELFCHECK_PHQ9_ALERT_POINT: 2,
  SELFCHECK_INTEX_TO_WEEK: [
    0, 2, 4, 8
  ],
  SELFCHECK_DEADLINE_DAYS: [
    0, 14, 22, 29
  ],
  SELFCHECK_ALERT_TERM: 4,

  SelfCheckIndexToWeek: (index: number): number => {
    return Setting.SELFCHECK_INTEX_TO_WEEK[index]
  },

  ENABLE_PHONE_NUMBER: false,
  ENABLE_UPDATE_CRC: false
}
